export enum NavigationType {
    Back,
    Next,
    Submit,
    Quit,
}
